// components/LanguageToggle.js — top-right EN/PL switch (mirrors ThemeToggle).
import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function LanguageToggle() {
  const { lang, setLang, languages } = useLang();
  const next = lang === 'en' ? 'pl' : 'en';
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <button
      type="button"
      className="btn btn-ghost btn-icon"
      title={`Language: ${current.label} — tap to switch`}
      onClick={() => setLang(next)}
      style={{ fontSize: '0.8rem', fontWeight: 700, minWidth: 44 }}
    >
      {current.flag} {lang.toUpperCase()}
    </button>
  );
}
